'use client';

import { type FC } from 'react';
import type { Team } from '@cs-shot/battle-sim';
import { cn } from '../../../utils/cn';
import { SideIcon } from '../SideIcon';

/**
 * The lobby SideSelector «briefing» VS banner — CT and T halves meeting on a diagonal — but
 * with only two options (no «Любая»). Used where the pick must be a concrete side: the create
 * sheet (the backend takes the creator's side) and the fighter tab team switch.
 */
export const TwoSideSelector: FC<{ side: Team; onPick: (side: Team) => void }> = ({ side, onPick }) => (
  <div className="relative h-24 overflow-hidden rounded-2xl border border-white/10">
    <button
      type="button"
      onClick={() => onPick('ct')}
      className={cn(
        'absolute inset-y-0 left-0 flex w-[54%] items-center gap-2 pl-4 transition-colors [clip-path:polygon(0_0,100%_0,82%_100%,0_100%)]',
        side === 'ct' ? 'bg-accent-blue/25' : 'bg-white/[0.04]',
      )}
    >
      <SideIcon side="ct" size={52} className={side === 'ct' ? '' : 'opacity-50'} />
      <span className={cn('text-lg font-extrabold tracking-wider', side === 'ct' ? 'text-accent-blue' : 'text-label-tertiary')}>CT</span>
    </button>
    <button
      type="button"
      onClick={() => onPick('t')}
      className={cn(
        'absolute inset-y-0 right-0 flex w-[54%] items-center justify-end gap-2 pr-4 transition-colors [clip-path:polygon(18%_0,100%_0,100%_100%,0_100%)]',
        side === 't' ? 'bg-gold/20' : 'bg-white/[0.04]',
      )}
    >
      <span className={cn('text-lg font-extrabold tracking-wider', side === 't' ? 'text-gold' : 'text-label-tertiary')}>T</span>
      <SideIcon side="t" size={52} className={side === 't' ? '' : 'opacity-50'} />
    </button>
  </div>
);
